export enum PromotionTypeEnum {
    ACCOUNT='ACCOUNT',
    CONTRACT='CONTRACT',
    COST_CENTER='COST_CENTER',
    PRODUCT='PRODUCT'
}